export default "{\n    \"todayLabel\": \"Aujourd'hui\"\n}\n"